import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ecb908de"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "add_response_drawer",
  class: "bg-white",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "activities",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'800px', 'md': '1050px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#add_response_drawer_toggle",
  "data-kt-drawer-close": "#add_response_drawer_close"
}
const _hoisted_2 = { class: "d-flex flex-column flex-row-fluid" }
const _hoisted_3 = { class: "rounded border border-dashed border-gray-300 py-4 px-6 mb-5" }
const _hoisted_4 = { class: "d-flex flex-stack pb-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-1" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-800 fw-bold mb-0 me-1" }, " Response Templates ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted" }, " Add or remove customized pages in the response. ")
], -1))
const _hoisted_6 = { class: "text-nowrap text-end me-2 col" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "btn btn-sm btn-success",
    "data-bs-toggle": "modal",
    "data-bs-target": "#chargeback_guide"
  }, " Guide ")
], -1))
const _hoisted_8 = { class: "d-flex flex-column-auto h-20px mb-5" }
const _hoisted_9 = { class: "card-title fw-bolder text-dark px-5" }
const _hoisted_10 = { class: "d-flex flex-row flex-column-fluid" }
const _hoisted_11 = { class: "d-flex flex-row-fluid bg-white w-1000px px-5 py-5" }
const _hoisted_12 = { class: "d-flex flex-row flex-column-fluid" }
const _hoisted_13 = { class: "d-flex flex-col-fluid bg-light scroll-y p-5" }
const _hoisted_14 = { class: "demo-image__lazy col-12 h-auto w-175px" }
const _hoisted_15 = { class: "flex-col p-3 fs-8 fw-bold" }
const _hoisted_16 = { class: "badge badge-white text-dark p-2 fs-8 fw-bold me-1" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Response Pages ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img_overlay" }, null, -1))
const _hoisted_19 = { class: "img_button_edit w-100" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "svg-icon svg-icon-3x svg-icon-white" }
const _hoisted_22 = { class: "img_button_remove w-100" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "svg-icon svg-icon-3x svg-icon-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor = _resolveComponent("editor")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_EvidenceListDrawer = _resolveComponent("EvidenceListDrawer")!
  const _component_UploadCustomImageEvidenceModal = _resolveComponent("UploadCustomImageEvidenceModal")!
  const _component_UploadCustomDocEvidenceModal = _resolveComponent("UploadCustomDocEvidenceModal")!
  const _component_GuideModal = _resolveComponent("GuideModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("a", {
                class: "btn btn-sm btn-success",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onEdit && _ctx.onEdit(...args)), ["prevent"]))
              }, "Add")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                class: "btn btn-sm btn-success me-2",
                ref: "submitButtonRef",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
              }, "Save", 512)
            ]),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.getTemplateName), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_editor, {
              "api-key": _ctx.editorApiKey,
              "max-width": "100%",
              init: _ctx.editorOption,
              modelValue: _ctx.cbResponse,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cbResponse) = $event))
            }, null, 8, ["api-key", "init", "modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.incoming.reason), 1),
              _hoisted_17
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateImages, (url, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "img_container align-items-center",
                key: index
              }, [
                _createVNode(_component_el_image, {
                  src: url,
                  "initial-index": index,
                  lazy: ""
                }, null, 8, ["src", "initial-index"]),
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("a", {
                    class: "w-175px",
                    onClick: ($event: any) => (_ctx.onSelTemplate(index))
                  }, [
                    _createElementVNode("span", _hoisted_21, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr066.svg" })
                    ])
                  ], 8, _hoisted_20)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("a", {
                    class: "w-175px",
                    onClick: ($event: any) => (_ctx.onRemoveTemplate(index))
                  }, [
                    _createElementVNode("span", _hoisted_24, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ], 8, _hoisted_23)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_component_EvidenceListDrawer, {
      incoming: _ctx.incoming,
      addedEvidences: _ctx.getAddedEvidences,
      drawer: _ctx.drawer,
      onAddEvidence: _ctx.onAddEvidence,
      onAddCustom: _ctx.onAddCustom,
      onClose: _ctx.onCloseEvidence
    }, null, 8, ["incoming", "addedEvidences", "drawer", "onAddEvidence", "onAddCustom", "onClose"]),
    _createVNode(_component_UploadCustomImageEvidenceModal, {
      evidence: _ctx.selectedCustomEvidence,
      incoming: _ctx.incoming,
      onAddEvidence: _ctx.onAddEvidence
    }, null, 8, ["evidence", "incoming", "onAddEvidence"]),
    _createVNode(_component_UploadCustomDocEvidenceModal, {
      evidence: _ctx.selectedCustomEvidence,
      incoming: _ctx.incoming,
      onAddEvidence: _ctx.onAddEvidence
    }, null, 8, ["evidence", "incoming", "onAddEvidence"]),
    _createVNode(_component_GuideModal, {
      reason_explained: _ctx.reason_explained,
      reason: _ctx.reason
    }, null, 8, ["reason_explained", "reason"])
  ], 64))
}